<div class="configuration-commitments-commitments-view-part">
	Commitments frid goes here
</div>